<template>
  <v-form v-bind="this.$attrs">
    <v-row class="d-flex justify-end">
      <v-col cols="12" md="3">
        <AutocompleteGrade v-model="grade" return-object label="Khối" outlined dense hide-details clearable />
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteClass
          v-model="classes"
          clear-icon="mdi-close"
          label="Lớp"
          clearable
          flat
          outlined
          dense
          return-object
          hide-details
          @change="classChanged"
        />
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteStudent
          v-model="student"
          return-object
          label="Học sinh"
          outlined
          dense
          hide-details
          clearable
          @change="studentChanged"
        />
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteTuitionPeriod v-model="tuitionPeriod" label="Kỳ đóng" placeholder="Kỳ đóng" hide-details />
      </v-col>
    </v-row>
    <v-row class="d-flex justify-end">
      <v-col cols="12" md="3">
        <v-select
          v-model="category"
          label="Loại phí"
          placeholder="Loại phí"
          :items="categoryOptions"
          item-value="value"
          item-text="name"
          outlined
          dense
          clearable
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="status"
          label="Bước hỗ trợ"
          placeholder="Bước hỗ trợ"
          :items="statusOptions"
          item-value="value"
          item-text="name"
          return-object
          outlined
          dense
          clearable
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="subStatus"
          label="Trạng thái chi tiết"
          placeholder="Trạng thái chi tiết"
          :items="filteredSubStatusOptions"
          item-value="value"
          item-text="name"
          outlined
          dense
          clearable
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteInCharge dense hide-details @change="setIncharge" multiple clearable />
      </v-col>
    </v-row>
    <v-row no-gutters class="d-flex justify-end mt-6">
      <v-col cols="12" md="3"> </v-col>
      <v-col cols="12" md="3"> </v-col>
      <v-col cols="12" md="3"> </v-col>
      <v-col cols="12" md="3" class="d-flex justify-end">
        <v-btn class="search-button" @click="filter" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade.vue'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import AutocompleteTuitionPeriod from '../../components/basic/input/AutocompleteTuitionPeriod.vue'
import AutocompleteInCharge from '../../components/basic/input/AutocompleteInCharge.vue'

export default {
  data() {
    return {
      classes: null,
      student: null,
      grade: null,
      tuitionPeriod: null,
      inCharge: null,
      category: null,
      status: null,
      subStatus: null,
      isAdvancedSearchEnabled: false,
      statusOptions: [
        { name: 'Chưa hỗ trợ', value: 'notSeen', step: 1 },
        { name: 'Đang hỗ trợ', value: 'inProgress', step: 2 },
        { name: 'Đã hỗ trợ', value: 'closed', step: 3 },
      ],
      subStatusOptions: [
        { name: 'Đã liên hệ', value: 'Đã liên hệ', step: 2 },
        { name: 'Đã phân tích vấn đề', value: 'Đã phân tích vấn đề', step: 2 },
        { name: 'Đang giải quyết', value: 'Đang giải quyết', step: 2 },
        { name: 'Có thay đổi', value: 'Có thay đổi', step: 3 },
        { name: 'Không thay đổi', value: 'Không thay đổi', step: 3 },
      ],
      categoryOptions: [
        { name: 'Học phí', value: 'cen' },
        { name: 'Thu hộ/Chi hộ', value: 'decen' },
        { name: 'Tất cả', value: 'all' },
      ],
    }
  },
  components: {
    AutocompleteStudent,
    AutocompleteClass,
    AutocompleteGrade,
    AutocompleteTuitionPeriod,
    AutocompleteInCharge,
  },
  async created() {
    await this.fetchClassesData()
  },
  computed: {
    ...mapState('class', ['classesData']),
    ...mapState('students', ['students']),

    currentClassId() {
      return { currentClass: get(this.classes, 'id') }
    },
    filteredSubStatusOptions() {
      if (this.status) {
        return this.subStatusOptions.filter((option) => option.step === this.status.step)
      } else {
        return this.subStatusOptions
      }
    },
  },
  watch: {
    status() {
      this.subStatus = null
    },
  },
  methods: {
    ...mapActions('class', ['fetchClassesData']),
    ...mapActions('students', ['searchStudents']),
    async filter() {
      const params = {
        class: get(this.classes, 'id'),
        grade: get(this.grade, 'id'),
        student: get(this.student, 'id'),
        inCharge_in: this.inCharge ? this.inCharge.map((item) => item.id) : null,
        category: this.category,
        subStatus: this.subStatus,
        period: get(this.tuitionPeriod, 'id'),
      }

      if (this.status) {
        params.status = this.status.value
      }
      this.$emit('onFilterChanged', params)
    },
    studentChanged(student) {
      this.classes = get(student, 'currentClass')
      this.grade = get(student, 'grade')
    },
    classChanged(classData) {
      this.grade = get(classData, 'grade')
      if (get(this.student, 'currentClass.id') !== get(classData, 'id')) this.student = null
    },
    setIncharge(data) {
      this.inCharge = data
    },
  },
}
</script>

<style scoped>
.text {
  width: 154px;
  height: 20px;

  /* Body regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height, or 143% */
  /* icon, sub */

  color: #797979;
}

.text-name {
  /* Toàn trường */
  width: 290px;
  height: 24px;

  /* H4 */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  /* identical to box height, or 133% */
  color: #000000;
}
</style>
